export default __webpack_public_path__ + "media/Dry-Food-Canned-Food.4e7c97ff.png";